// 認證相關工具函數

const LOGIN_URL = 'https://login.qsearch.cc';

// 避免多個並發請求同時 401 時重複觸發跳轉
let isRedirecting = false;

/**
 * 重定向到登入頁面，並帶上目前頁面作為登入後的回跳目標。
 * 註：回跳需 login.qsearch.cc 支援 redirect query param 才會生效；不支援時
 * 也只是被忽略，不影響登入。
 */
export const redirectToLogin = (): void => {
  if (isRedirecting) return;
  isRedirecting = true;
  const redirect = encodeURIComponent(window.location.href);
  window.location.href = `${LOGIN_URL}?redirect=${redirect}`;
};

/**
 * 檢查是否為未授權錯誤
 * @param error 錯誤對象
 * @returns 是否為 401 錯誤
 */
export const isUnauthorizedError = (error: any): boolean => {
  return error && error.response && error.response.status === 401;
};

/**
 * 處理 API 錯誤，如果是 401 則重定向到登入頁面
 * @param error 錯誤對象
 * @returns 是否已處理錯誤（401 情況）
 */
export const handleApiError = (error: any): boolean => {
  if (isUnauthorizedError(error)) {
    redirectToLogin();
    return true;
  }
  return false;
}; 